import { Box, Button, Text } from "@chakra-ui/react";
import React from "react";
import { getBlogCardStyles } from "../../utils";

// blog card
const Card = ({ blog, index }) => {
  const date = new Date(blog.date.seconds * 1000);
  const formattedDate = date.toLocaleString("en-US", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
  const design = getBlogCardStyles(index);
  return (
    <Box
      color="#fff"
      padding={4}
      borderRadius="15px"
      bg={design.bgColor}
      border={`1px solid ${design.borderColor}`}
      w="450px"
      minH="275px"
      display="flex"
      flexDir="column"
      justifyContent="space-between"
    >
      <Box>
        {/* title */}
        <Text fontSize="1.5rem" lineHeight="1.3" fontWeight="500" mb="1rem">
          {blog.title}
          {/* Clean coding */}
        </Text>
        {/* tags */}
        <Box display="flex" alignItems="center" gap={4}>
          {blog.tags.map((tag) => {
            return (
              <Box
                key={tag}
                bg={design.tagBgColor}
                p="0.25rem 0.4rem"
                textAlign="center"
                borderRadius="0.25rem"
              >
                <Text
                  color={design.tagColor}
                  fontWeight="500"
                  fontSize="0.9rem"
                >
                  {tag}
                  {/* Software development */}
                </Text>
              </Box>
            );
          })}
        </Box>
        {/* desc */}
        <Text
          color={design.textColor}
          fontSize="1.15rem"
          lineHeight="1.3"
          my="1.75rem"
        >
          {blog.desc}
        </Text>
      </Box>
      {/* footer */}
      <Box
        p="15px 35px"
        m="0 -15px -15px -15px"
        bg="rgba(0,0,0,0.3)"
        borderTop={`1px solid ${design.borderColor}`}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        borderBottomLeftRadius="15px"
        borderBottomEndRadius="15px"
      >
        <Text color="#fff" fontSize="14px">
          {/* 10 April, 2023 */}
          {formattedDate}
        </Text>
        <Button
          variant="unstyled"
          bg="#fff"
          color="#343a40"
          borderRadius="0.25rem"
          p="0.75rem 1.15rem"
          onClick={() => {
            window.open(blog.preview_link, "_blank", "noopener,noreferrer");
          }}
        >
          View Blog
        </Button>
      </Box>
    </Box>
  );
};

export default Card;
